import { IApplicationModel } from "../../../../service/application/entity/IApplicationModel";

export const removeThirdVesrsionAuditExtend = (renderAuditList: IApplicationModel[], currentApplication: IApplicationModel) => {
  let thirdVersionAudits: IApplicationModel[] = [];
  const elementPositionsToRemove: number[] = [];

  let isChangedSecondVersion = false;
  renderAuditList.reverse()

  for (let i = 0; i < renderAuditList.length - 1; i++) {
    const nextAudit = renderAuditList[i + 1];
    const audit = renderAuditList[i];
    const version = audit.versionNumber?.split('.');
    const nextAuditVersion = nextAudit.versionNumber?.split('.');

    if (version && nextAuditVersion) {
      if (isChangedSecondVersion) {
        if (audit.versionNumber === nextAudit.versionNumber || nextAuditVersion[1] === '0') {
          isChangedSecondVersion = false;
        }
        continue;
      }

      if (+nextAuditVersion[0] - +version[0] > 0) {
        audit.versionNumber = `${nextAuditVersion[0]}.0.0`;
        if (+nextAuditVersion[1] != 0) {
          isChangedSecondVersion = true;
        }
        continue;
      }

      if (+nextAuditVersion[1] - +version[1] > 0) {
        isChangedSecondVersion = true;
        if (+nextAuditVersion[0] - +version[0] === 0) {
          audit.versionNumber = `${version[0]}.${version[1]}.${version[2] + 1}`;
          elementPositionsToRemove.push(i);
        }
        continue;
      }
      audit.versionNumber = `${version[0]}.${version[1]}.${version[2] + 1}`;
      elementPositionsToRemove.push(i);
    }
  };

  const lastAudit = renderAuditList[renderAuditList.length - 1];
  const version = lastAudit.versionNumber?.split('.');
  const currentVersion = currentApplication.versionNumber?.split('.');

  if (version && currentVersion) {
    if (renderAuditList.length === 1 && version[0] === '0') {
      lastAudit.versionNumber = `1.0.0`;
    } else if (isChangedSecondVersion || lastAudit.versionNumber === currentApplication.versionNumber) {
      isChangedSecondVersion = false;
    } else if (+currentVersion[0] - +version[0] > 0) {
      lastAudit.versionNumber = `${currentVersion[0]}.0.0`;
      if (+currentVersion[1] - +version[1] > 0) {
        isChangedSecondVersion = true;
      }
    } else if (+currentVersion[1] - +version[1] > 0) {
      isChangedSecondVersion = true;
      if (+currentVersion[2] - +version[2] != 0) {
        lastAudit.versionNumber = `${version[0]}.${version[1]}.${version[2] + 1}`;
        elementPositionsToRemove.push(renderAuditList.length - 1);
      }
    } else {
      elementPositionsToRemove.push(renderAuditList.length - 1)
    }
  }

  const uniqueIterators = [...new Set(elementPositionsToRemove)];
  uniqueIterators.reverse().forEach((item) => {
    thirdVersionAudits = [...thirdVersionAudits, renderAuditList[item]];
    renderAuditList.splice(item, 1);
  });
  renderAuditList.reverse();
  return { renderList: renderAuditList, thirdVersionAudits: thirdVersionAudits };
}
